import { Test } from "../stores/TestsStore";

export class TestHelper {

  static filterAvailableTests(
    allTests: Test[],
    existUserAssignments: { testId: number }[],
    userSkills: { name: string, levelName: string, isConfirmed: boolean }[]
  ): Test[] {
    const assignedTestIds = new Set(existUserAssignments.map(a => a.testId));
    const skillLevelPriority = { "junior": 1, "middle": 2, "senior": 3 } as const;

    return allTests.filter(test => {
      if (assignedTestIds.has(test.id)) return false;

      const testSkill = userSkills.find(skill => skill.name === test.name);

      const testLevelKey = test.level?.toLowerCase() as keyof typeof skillLevelPriority;
      const testLevel = skillLevelPriority[testLevelKey] ?? skillLevelPriority["junior"];

      if (!testSkill) {
        return testLevel === skillLevelPriority["junior"];
      }

      const userLevelKey = testSkill.levelName?.toLowerCase() as keyof typeof skillLevelPriority;
      const userLevel = skillLevelPriority[userLevelKey] ?? 0;

      if (testSkill.isConfirmed) {
        return testLevel > userLevel;
      } else {
        return testLevel >= userLevel;
      }
    });
  }

  static getImageSkill(skillTitle: string) {

    if (skillTitle == "unknown_skill") {
      return "/assets/img/test/Test.jpg";
    }
    else if (skillTitle == "C# (Programming Language)") {
      return "/assets/img/test/CSharp.jpg";
    }
    else if (skillTitle == "Unity (C#)") {
      return "/assets/img/test/Unity.jpg";
    }
    else {
      return `/assets/img/test/${skillTitle}.jpg`;
    }
  }
}